import { render } from "./StepGenres.vue?vue&type=template&id=24be34a9"
import script from "./StepGenres.vue?vue&type=script&lang=js"
export * from "./StepGenres.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__